<section class="hero">
  <div>
    <p class="eyebrow">Analytics</p>
    <h1>Trends</h1>
  </div>

  <div class="interval-toggle">
    <button type="button"
      [class.active]="interval() === 'week'"
      (click)="changeInterval('week')">Weekly</button>
    <button type="button"
      [class.active]="interval() === 'day'"
      (click)="changeInterval('day')">Daily</button>
  </div>
</section>

@if (data(); as bundle) {
  @if (latestPoint; as latest) {
    <section class="metric-grid">
      <app-metric-card label="Total Issues" [value]="latest.totalIssues" hint="Latest period" tone="warn" />
      <app-metric-card label="Block Rate" [value]="(latest.blockRate | number:'1.1-1') + '%'" hint="Latest period" tone="danger" />
      <app-metric-card label="PRs" [value]="latest.pullRequestCount" hint="Latest period" />
      <app-metric-card label="Avg Issues / PR" [value]="(latest.avgIssuesPerPullRequest | number:'1.1-2') ?? '0'" hint="Latest period" />
      <app-metric-card label="Failed Reviews" [value]="latest.failedReviewCount" hint="Latest period" />
    </section>
  }

  @if (bundle.points.length) {
    <section class="chart-grid">
      <article class="panel chart-panel">
        <div class="panel-head">
          <div>
            <p class="panel-kicker">Issue Volume</p>
            <h2>Issues over time</h2>
          </div>
        </div>
        <div class="chart-shell">
          <canvas baseChart [data]="issueVolumeChartData()" [type]="'line'" [options]="lineChartOptions"></canvas>
        </div>
      </article>

      <article class="panel chart-panel">
        <div class="panel-head">
          <div>
            <p class="panel-kicker">Block Rate</p>
            <h2>Blocked verdict % over time</h2>
          </div>
        </div>
        <div class="chart-shell">
          <canvas baseChart [data]="blockRateChartData()" [type]="'line'" [options]="lineChartOptions"></canvas>
        </div>
      </article>

      <article class="panel chart-panel">
        <div class="panel-head">
          <div>
            <p class="panel-kicker">PR Volume</p>
            <h2>Pull requests and review runs</h2>
          </div>
        </div>
        <div class="chart-shell">
          <canvas baseChart [data]="prVolumeChartData()" [type]="'bar'" [options]="barChartOptions"></canvas>
        </div>
      </article>

      <article class="panel chart-panel">
        <div class="panel-head">
          <div>
            <p class="panel-kicker">Quality</p>
            <h2>Average issues per PR</h2>
          </div>
        </div>
        <div class="chart-shell">
          <canvas baseChart [data]="avgIssuesChartData()" [type]="'line'" [options]="lineChartOptions"></canvas>
        </div>
      </article>
    </section>
  } @else {
    <section class="state-card">
      <p>No trend data available for the selected range and interval.</p>
    </section>
  }
} @else if (loading()) {
  <section class="state-card">Loading trends…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="state-button" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No trend data returned for the selected range.</p>
  </section>
}
